import { QuestionID } from "./questions";
export function getPreviouslyVisitedResorts(answered, resorts) {
    const questionAnswer = answered.tryGetByID(QuestionID.PreviouslyVisitedResorts);
    const previouslyVisitedAnswer = questionAnswer ? questionAnswer.answer : undefined;
    if (previouslyVisitedAnswer && previouslyVisitedAnswer.selected instanceof Set) {
        const pickedResortIds = previouslyVisitedAnswer.selected;
        return resorts.filter((r) => pickedResortIds.has(r.integer_id));
    }
    return [];
}
;
